var exports = {
  "k": "x234b8571--89f51a--container",
  "m": "x234b8571--89f51a--reaction",
};

module.exports = exports;
